import { useEffect, useState } from "react";
import CountUp from "react-countup";
import axios from "axios";
import { useOutletContext } from "react-router-dom";
import { currency_converter_inr, currency_converter_selected } from "../../../utils/currencyUtils";

function SelfGenerationReffered() {
  const { selectedUser, year, setGlobalLoading, token } =  useOutletContext();
  const [options, setoptions] = useState([]);
  const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const formatNumber = (value) => {
    return currency_converter_selected(Number(value || 0));
  };

  function RevenueCounter({ value }) {
    return (
      <CountUp
        start={0}
        end={Number(value || 0)}
        duration={1}
        formattingFn={currency_converter_selected}
      />
    );
  }

  useEffect(() => {
    if (!selectedUser) return;
    let isLatest = true;
    const getOverview = async () => {
      try {
        setGlobalLoading(true);
        const response = await axios.get(
          `${REACT_APP_API_BASE_URL}/performance/self_generation_data`,
          {
            params: {
              user_id: selectedUser.id,
              year: year,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!isLatest) return;

        if (response.status === 200) {
          setoptions(response.data?.revenue_selfgen_reffered || []);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setGlobalLoading(false);
      }
    };

    getOverview();

    return () => {
      isLatest = false;
    };
  }, [selectedUser, year]);

  const getTotal = (key) => {
    return options.reduce(
      (sum, row) => sum + Number(row[key] || 0),
      0
    );
  };

  return (
    <>
      <div className="card">
        <div className="card-body">

          <div className="border-bottom mb-3 pb-3">
            <h4>Self Generated Revenue</h4>
            <p className="text-muted fs-13 mb-1">
              Track invoicing & collection
            </p>
          </div>

          <div className="row">
            <div className="col-md-12 col-xl-12 col-xxl-12">
              <div className="table-responsive" style={{ maxHeight: "500px" }}>
                <table className="table table-bordered text-nowrap align-middle">
                  <thead className="table-dark" style={{ position: "sticky", top: 0, zIndex: 1}}>

                    <tr>
                      <th rowSpan="2">YEAR</th>
                      <th colSpan="4" className="text-center">Self Generated</th>
                      <th rowSpan="2">Total - Self Gen</th>
                      <th rowSpan="2">Total - Referred</th>
                      <th colSpan="2" className="text-center">COLLECTED</th>
                      <th colSpan="2" className="text-center">UNBILLED</th>
                      <th colSpan="2" className="text-center">UNCOLLECTED</th>
                    </tr>

                    <tr>
                      <th>Q1</th>
                      <th>Q2</th>
                      <th>Q3</th>
                      <th>Q4</th>
                      <th>Self Gen</th>
                      <th>Referred</th>
                      <th>Self Gen</th>
                      <th>Referred</th>
                      <th>Self Gen</th>
                      <th>Referred</th>
                    </tr>
                  </thead>
                  <tbody>
                    {options?.map((row, index) => (
                      <tr key={index}>
                        <td className="fw-bold">{row.financial_year}</td>
                        <td><RevenueCounter value={row.Q1} /></td>
                        <td><RevenueCounter value={row.Q2} /></td>
                        <td><RevenueCounter value={row.Q3} /></td>
                        <td><RevenueCounter value={row.Q4} /></td>
                        <td className="fw-semibold"><RevenueCounter value={row.total_self_generated} /></td>
                        <td className="fw-semibold"><RevenueCounter value={row.total_referred} /></td>
                        <td><RevenueCounter value={row.collected_self_gen} /></td>
                        <td><RevenueCounter value={row.collected_referred} /></td>
                        <td><RevenueCounter value={row.unbilled_self_gen} /></td>
                        <td><RevenueCounter value={row.unbilled_referred} /></td>
                        <td><RevenueCounter value={row.uncollected_self_gen} /></td>
                        <td><RevenueCounter value={row.uncollected_referred} /></td>
                      </tr>
                    ))}
                    {/* TOTAL ROW */}
                    <tr className="table-secondary fw-bold">
                      <td>Total</td>
                      <td>{formatNumber(getTotal("Q1"))}</td>
                      <td>{formatNumber(getTotal("Q2"))}</td>
                      <td>{formatNumber(getTotal("Q3"))}</td>
                      <td>{formatNumber(getTotal("Q4"))}</td>
                      <td>{formatNumber(getTotal("total_self_generated"))}</td>
                      <td>{formatNumber(getTotal("total_referred"))}</td>
                      <td>{formatNumber(getTotal("collected_self_gen"))}</td>
                      <td>{formatNumber(getTotal("collected_referred"))}</td>
                      <td>{formatNumber(getTotal("unbilled_self_gen"))}</td>
                      <td>{formatNumber(getTotal("unbilled_referred"))}</td>
                      <td>{formatNumber(getTotal("uncollected_self_gen"))}</td>
                      <td>{formatNumber(getTotal("uncollected_referred"))}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SelfGenerationReffered;